import React from 'react'
import { FaSearch, FaBell, FaPlus, FaInbox, FaCodeBranch,FaList } from "react-icons/fa";
import { useLocation } from 'react-router';
import QuickLinks from './QuickLinks';

function HomeAdmin() {

  const CreateStaff = (e)=>{
    e.preventDefault()
    // setActiveAction("create-staff")
  }

  const EditStaff = (e)=>{
    e.preventDefault()
    // setActiveAction("edit-staff")
  }

  const ListStaff = (e)=>{
    e.preventDefault()
    // setActiveAction("list-staff")
  }
  return (
    
        <div>
                    {/* <h3>ProjectAdmin</h3> */}
                <header className="projects-header-admin">
                  <h1 className="header-title-admin">Home Admin</h1>
            
                  <div className="header-controls-admin">
                    <div className="search-container">
                      <FaSearch className="search-icon" />
                      <input
                        type="text"
                        placeholder="Type / to search"
                        className="search-input"
                      />
                    </div>
            
                    <div className="icon-group">
                      <button className="icon-button tooltip-container" onClick={CreateStaff}>
                        <FaPlus /> <span>Add News</span> 
                        {/* <span class="tooltip-content">Add New Staff</span> */}
                      </button>
                      <button className="icon-button tooltip-container" onClick={ListStaff}>
                        <FaList /> <span>View Staff</span> <span class="tooltip-content">List All Staffs</span>
                      </button>
                      <button className="icon-button">
                        <FaCodeBranch />
                      </button>
                      <button className="icon-button">
                        <FaInbox />
                      </button>
                    </div>
                  </div>
                </header>
                <div>
                  {/* {
                    views[activeAction] || views['list-staff']
                  } */}
                  <QuickLinks/>
                </div>
                </div>
  )
}

export default HomeAdmin